const productInfoDataSanitizer = product => ({
  approximatedConvertedPrice: product.converted_rrp,
  approximatedConvertedPriceCurrencyIso: product.approximated_converted_price_currency_iso,
  brand: product.brand,
  brandId: product.brand_id,
  brandUrl: product.brand_url,
  categoryPath: product.category_path,
  color: product.color,
  currentPrice: product.rrp,
  isActive: product.product_is_active,
  originalPrice: product.rrp_not_reduced,
  productId: product.product_id,
  productName: product.model,
  productUrl: product.url,
  productVersionId: product.product_version_id,
  reductionPercentage: product.reduction,
  season: product.season,
});

export default productInfoDataSanitizer;
